export default {"src":"/_next/static/media/bcg_for_dark_themes.81d80719.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};